import { Button, Flex } from "antd";
import Sider from "antd/es/layout/Sider";
import { styled } from "styled-components";

export const SidebarContainer = styled(Sider)`

    @media (max-width: 810px) {
        display: none;
    }
`;

export const SidebarTitle = styled.span`
    font-family: NeueWorld-Black;
    font-size: 2rem;
    position: relative;
    width: 100%;
    text-align: center;
    color: white;

    &::after {
        content: "";
        display: block;
        width: min(100%, 600px);
        height: 0px;
        border: .5px solid #9CA3AF;
        position: absolute;
        bottom: -20px;
        right: 0;
        transform: rotate(-15deg);
    }

    @media (max-width: 810px) {
        display: none;
    }

`;

export const SmallSidebarTitle = styled.span`
    font-family: NeueWorld-Black;
    font-size: 2rem;
    position: relative;
    width: 100%;
    text-align: center;
    color: white;
`;

export const Back = styled(Button)`
    position: absolute;
    top: 20px;
    z-index: 3;
    width: fit-content;

    @media (min-width: 810px) {
        display: none;
    }
`;

export const SmallSubcategoriesContainer = styled(Flex)`
    max-width: 60%;

    @media (min-width: 1200px) {
        display: none;
    }
`;

export const ProductName = styled.span`
    font-size: 1.5rem;
    letter-spacing: 1px;
    font-family: NeueWorld-Thin;
    color: white;
`;

export const ProductDescription = styled.span`
    font-size: 0.9rem;
    font-family: Roboto-Thin;
    color: white;
`;

export const SubcategorySection = styled.span`
    font-family: Roboto-Thin;
    font-size: 0.9rem;
    letter-spacing: 1px;
    background-color: #595959;
    color: white;
    width: fit-content;
    padding: 15px 30px;
    border-radius: 5px;
    margin-bottom: 30px;
`;

export const PriceLabel = styled.span`
    font-size: 1.1rem;
    font-family: Roboto-Thin;
    color: white;
`;

export const ProductsContainer = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 20px;
    width: 90%;

    @media (max-width: 1600px) {
        grid-template-columns: 1fr 1fr 1fr;
    }
   
    @media (max-width: 900px) {
        grid-template-columns: 1fr 1fr;
    }
    
    @media (max-width: 730px) {
        grid-template-columns: 1fr;
    }
`;

export const ProductContainer = styled.div`
    display: grid;
    grid-template-columns: 2fr 1fr;
    gap: 10px;
    background-color: rgb(42, 42, 42);
    padding: 10px 10px;
    border-radius: 5px;
`;